<template>
  <div class="dd-about">
    <div class="about-banner">
      <div class="about-banner-bg">
        <img class="banner-bg-img" src="../../assets/img/about/about-banner-bg-01.png"/>
        <div class="banner-bg-img-mobile"/>
      </div>
      <div class="about-banner-content">
        <img src="../../assets/img/about/logo.png"/>
        <div class="banner-content-title">让小企业轻松应用物联网技术提升生产力</div>
      </div>
    </div>
    <div class="about-summary">
      <div class="about-container">
        <div class="about-summary-company">
          <div class="company-desc">佛山点度物联科技有限公司是一家致力于为制造企业提供优质的数字化转型升级服务，为客户提供一整套工业装备数据智能采集与分析系统解决方案。团队打造了自主研制国内领先的数据采集与分析的点度智联云系统，拥有业界领先的数据采集技术，集协议、PLC、仪表、传感器的数据采集于一体，响应速度和采集频率可达毫秒级，能覆盖各品类新老设备；还提供高效、稳定、准确的数据传输，存储与可视化服务：如OEE、车间可视化管理、设备状态与信息、加工报警信息、产能等实时统计。更可通过工业大数据分析模型，实现设备的数据化与智能化，如质量预测、工艺优化、设备智能运维等应用。</div>
          <div class="company-desc">佛山点度物联科技有限公司成立至今，以成功在电镀、水处理、锅炉、粉尘环保、木工机械、陶瓷喷釉、五金加工等行业上落地应用。通过高性价比的产品和服务，获得了客户的一致认可，为我国制造业转型升级提供助力。</div>
        </div>
        <div class="about-summary-culture">
          <div class="company-culture-left left">
            <img src="../../assets/img/about/about-company-culture.png"/>
          </div>
          <div class="company-culture-right left">
            <div class="company-culture-item">
              <div class="company-culture-title">企业远景：</div>
              <div class="company-culture-sub-title">为设备赋智、为企业赋值、为行业赋能</div>
            </div>
            <div class="company-culture-item c-c-item-middle">
              <div class="company-culture-title">企业使命：</div>
              <div class="company-culture-sub-title">让小企业轻松应用物联网技术提升生产力</div>
            </div>
            <div class="company-culture-item c-c-item-middle">
              <div class="company-culture-title">企业文化：</div>
              <div class="company-culture-sub-title">成就客户、诚信互信、奋斗为本，创新进取</div>
            </div>
          </div>
          <div class="clear"></div>
        </div>
      </div>
      <div class="clear"></div>
    </div>
    <div class="about-certificate">
      <div class="about-container">
        <div class="certificate-title">软著&专利</div>
        <div class="certificate-group">
          <div class="certificate-group-item left">
            <img src="../../assets/img/about/about-certificate-01.jpg"/>
          </div>
          <div class="certificate-group-item left">
            <img src="../../assets/img/about/about-certificate-02.jpg"/>
          </div>
          <div class="certificate-group-item left">
            <img src="../../assets/img/about/about-certificate-03.jpg"/>
          </div>
          <div class="certificate-group-item left">
            <img src="../../assets/img/about/about-certificate-04.jpg"/>
          </div>
          <div class="certificate-group-item left">
            <img src="../../assets/img/about/about-certificate-05.jpg"/>
          </div>
          <div class="certificate-group-item group-item-first left">
            <img src="../../assets/img/about/about-certificate-06.jpg"/>
          </div>
          <div class="certificate-group-item left">
            <img src="../../assets/img/about/about-certificate-07.jpg"/>
          </div>
          <div class="certificate-group-item left">
            <img src="../../assets/img/about/about-certificate-08.jpg"/>
          </div>
          <div class="certificate-group-item left">
            <img src="../../assets/img/about/about-certificate-09.jpg"/>
          </div>
          <div class="clear"></div>
        </div>
      </div>
    </div>
    <div class="about-contact">
      <div class="about-container">
        <div class="contact-title">联系我们</div>
        <div class="contact-company">佛山点度物联科技有限公司</div>
        <div class="contact-address">佛山市禅城区季华一路智慧新城T15栋1204室<br/>186-888-04710（Tel）<br/>3538279609（QQ）<br/>diandu_team@163.com</div>
        <div class="contact-website">https://www.dianduiot.com</div>
        <div class="contact-qrcode">
          <img src="../../assets/img/home/dd-personal-qrcode.png"/>
        </div>
        <div class="company-map-mask">
          <div class="company-map" id="ALL_MAP_TEST"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AMap from 'AMap'
export default {
  name: 'index',
  data () {
    return {
      map: {
        instance: null
      }
    }
  },
  mounted () {
    this.map.instance = new AMap.Map('ALL_MAP_TEST', {
      resizeEnable: true,
      center: [113.0568212271, 23.0073891518],
      zoom: 13
    })
    this.addMarker()
  },
  methods: {
    addMarker () {
      let marker = new AMap.Marker({
        position: [113.0568212271, 23.0073891518]
      })
      this.map.instance.add(marker)
      marker.setTitle('佛山市禅城区季华一路智慧新城T15楝1204-2室')
      marker.setLabel({
        offset: new AMap.Pixel(20, 20),
        content: "<div class='infoLabel'>佛山点度物联科技有限公司</div>"
      })
    }
  }
}
</script>

<style scoped>
  .about-container {
    width: 100%;
    max-width: 1130px;
    margin: auto;
    padding: 0 15px;
    box-sizing: border-box;
  }
  .about-banner-bg {
    width: 100%;
    position: relative;
  }
  .about-banner-bg img {
    width: 100%;
    height: auto;
  }
  .banner-bg-img-mobile {
    height: 170px !important;
    background: url("../../assets/img/about/about-banner-bg.png") no-repeat center;
    background-size: cover;
    display: none;
  }
  .about-banner-content {
    position: absolute;
    width: 100%;
    top: 130px;
    text-align: center;
  }
  .about-banner-content img {
    width: 140px;
    height: auto;
    margin: auto;
  }
  .banner-content-logo-text {
    font-size: 32px;
    color: #ffffff;
  }
  .banner-content-title {
    font-size: 54px;
    color: #ffffff;
    margin-top: 20px;
  }
  .about-summary {
    width: 100%;
    background-color: #ffffff;
    padding-top: 20px;
    padding-bottom: 95px;
  }
  .company-desc {
    text-indent: 2em;
    font-size: 17px;
    color: #010D1C;
    line-height: 36px;
    padding-top: 18px;
  }
  .about-summary-culture {
    margin-top: 40px;
  }
  .company-culture-left {
    width: 360px;
    height: 255px;
  }
  .company-culture-left img {
    width: 360px;
    height: 255px;
  }
  .company-culture-right {
    width: calc(100% - 415px);
    margin-left: 45px;
  }
  .company-culture-item {
    width: 100%;
    margin-top: 10px;
  }
  .c-c-item-middle {
    margin-top: 35px;
  }
  .company-culture-title {
    font-size: 18px;
    color: #010D1C;
  }
  .company-culture-sub-title {
    font-size: 23px;
    color: #010D1C;
    margin-top: 3px;
  }
  .about-certificate {
    background: url("../../assets/img/about/about-certificate-bg.png") no-repeat center;
    background-size: cover;
  }
  .certificate-title {
    font-size: 45px;
    color: #fff;
    text-align: center;
    padding-top: 30px;
  }
  .certificate-group {
    width: 100%;
    margin-top: 60px;
    padding-bottom: 74px;
  }
  .certificate-group-item {
    width: 20%;
    padding: 15px;
    box-sizing: border-box;
  }
  .certificate-group-item img{
    width: 100%;
  }
  .group-item-first {
    margin-left: 10%;
  }
  .about-contact {
    width: 100%;
    background-color: #ffffff;
    padding-bottom: 60px;
  }
  .contact-title {
    font-size: 45px;
    color: #010D1C;
    text-align: center;
    padding-top: 36px;
  }
  .contact-company {
    font-size: 24px;
    color: #010D1C;
    text-align: center;
    margin-top: 30px;
    font-weight: bold;
  }
  .contact-address {
    font-size: 16px;
    color: #010D1C;
    text-align: center;
    margin-top: 17px;
    line-height: 29px;
  }
  .contact-website {
    font-size: 16px;
    color: #010D1C;
    text-align: center;
    line-height: 29px;
    font-weight: bold;
  }
  .contact-qrcode img{
    width: 200px;
    height: auto;
    margin: auto;
  }
  .company-map-mask {
    width: 100%;
    height: 650px;
    margin-top: 20px;
    box-sizing: border-box;
  }
  .company-map {
    width: 100%;
    height: 100%;
    margin: auto;
  }
  @media all and (max-width: 1430px) {
    .about-banner-content {
      top: 110px;
    }
    .about-banner-content img {
      width: 80px;
    }
    .banner-content-logo-text {
      font-size: 22px;
    }
    .banner-content-title {
      font-size: 32px;
      margin-top: 10px;
    }
    .contact-qrcode img{
      width: 150px;
    }
    .company-map-mask {
      padding: 0 50px;
      height: 550px;
    }
  }
  @media all and (max-width: 1200px) {
    .company-culture-right {
      width: calc(100% - 390px);
      margin-left: 30px;
    }
    .company-culture-item {
      margin-top: 0;
    }
    .c-c-item-middle {
      margin-top: 20px;
    }
  }
  @media all and (max-width: 1000px) {
    .about-banner-content {
      top: 90px;
    }
    .about-banner-content img {
      width: 60px;
    }
    .banner-content-logo-text {
      font-size: 18px;
    }
    .banner-content-title {
      font-size: 24px;
      margin-top: 10px;
    }
    .company-map-mask {
      height: 450px;
    }
  }
  @media all and (max-width: 750px) {
    .banner-bg-img {
      display: none;
    }
    .banner-bg-img-mobile {
      display: block;
    }
    .about-banner-content {
      display: none;
    }
    .about-summary {
      padding-top: 0;
    }
    .company-culture-left {
      width: 100%;
      height: unset;
    }
    .company-culture-left img {
      width: 100%;
      max-width: 360px;
      margin: auto;
    }
    .company-culture-right {
      width: 100%;
      margin-left: 0;
      margin-top: 30px;
    }
    .certificate-group-item {
      width: 33.3%;
    }
    .group-item-first {
      margin-left: 0;
    }
    .company-map-mask {
      padding: 0 10px;
      height: 280px;
    }
  }
  @media all and (max-width: 500px) {
    .company-desc {
      font-size: 14px;
      line-height: 28px;
    }
    .company-culture-title {
      font-size: 16px;
    }
    .company-culture-sub-title {
      font-size: 18px;
    }
    .about-summary {
      padding-bottom: 40px;
    }
    .certificate-title {
      font-size: 32px;
    }
    .certificate-group {
      margin-top: 10px;
      padding-bottom: 30px;
    }
    .certificate-group-item {
      width: 50%;
      padding: 10px;
    }
    .about-certificate {
      background: #C6A109;
    }
    .contact-title {
      font-size: 32px;
    }
  }
  @media all and (max-width: 500px) {
    .company-map-mask {
      padding: 0;
      height: 250px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/about/index.vue